// extracted by mini-css-extract-plugin
module.exports = {"Profile":"_DQWllDgeSQCXCzcEDv8"};